import { Stack, Typography, useTheme } from "@mui/material";
import { ShredUsageSparkline } from "../settings/ShredUsageSparkline";
import {
  SHRED_USAGE_WARNING_THRESHOLD,
  ShredUsageDataPoint,
  formatShredUsage,
} from "./useTenantShredUsage";

export const TenantShredUsageDisplay = ({
  mixPercentage,
  formattedMonth,
  dataPoints,
}: {
  mixPercentage: number;
  formattedMonth: string;
  dataPoints: ShredUsageDataPoint[];
}) => {
  const theme = useTheme();

  const color =
    mixPercentage >= SHRED_USAGE_WARNING_THRESHOLD
      ? theme.palette.error.main
      : theme.palette.success.main;

  return (
    <Stack direction="row" alignItems="center" gap={1}>
      <ShredUsageSparkline dataPoints={dataPoints} color={color} />
      <Stack alignItems="center" justifyContent="center" sx={{ pr: 1.5 }}>
        <Typography
          variant="h5"
          sx={{
            fontWeight: "bold",
            color,
          }}
        >
          {formatShredUsage(mixPercentage)}
        </Typography>
        <Typography variant="body2" color="text.secondary">
          ({formattedMonth})
        </Typography>
      </Stack>
    </Stack>
  );
};
